var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCamera = function SvgCamera(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 6H4.38197C4.76074 6 5.107 5.786 5.27639 5.44721L6 4C6.61287 2.77427 7.86566 2 9.23607 2H14.7639C16.1343 2 17.3871 2.77427 18 4L18.7236 5.44721C18.893 5.786 19.2393 6 19.618 6H21.5C22.8807 6 24 7.11929 24 8.5V19C24 20.6569 22.6569 22 21 22H3C1.34315 22 0 20.6569 0 19V8.5C0 7.11929 1.11929 6 2.5 6ZM2.5 8C2.22386 8 2 8.22386 2 8.5V19C2 19.5523 2.44772 20 3 20H21C21.5523 20 22 19.5523 22 19V8.5C22 8.22386 21.7761 8 21.5 8H19.618C18.4817 8 17.4429 7.35799 16.9348 6.34164L16.2111 4.89443C15.9371 4.34626 15.3768 4 14.7639 4H9.23607C8.6232 4 8.06294 4.34626 7.78885 4.89443L7.06525 6.34164C6.55707 7.35799 5.51828 8 4.38197 8H2.5ZM12 18C9.23858 18 7 15.7614 7 13C7 10.2386 9.23858 8 12 8C14.7614 8 17 10.2386 17 13C17 15.7614 14.7614 18 12 18ZM12 16C13.6569 16 15 14.6569 15 13C15 11.3431 13.6569 10 12 10C10.3431 10 9 11.3431 9 13C9 14.6569 10.3431 16 12 16Z",
    fill: "#272163"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCamera, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/camera.61e0f93b.svg";
export { ForwardRef as ReactComponent };